import http from "../utils/request";
import { areaTree } from "./setting";
import type { ShopResponse } from "../types/shopMerchant";

export interface ShopReturnAddressWrite {
  id?: number;
  receiverName: string;
  receiverPhone: string;
  province: number;
  city: number;
  district: number;
  detailAddress: string;
  isDefault: number;
  sort: number;
  status: number;
}
export interface ShopReturnAddress extends ShopReturnAddressWrite {
  id: number;
  merchantId: number;
  provinceName?: string;
  cityName?: string;
  districtName?: string;
  createTime?: string;
  updateTime?: string;
}
export interface ReturnAddressArea { id: number; name: string; parentId: number }

export function listShopReturnAddresses(signal?: AbortSignal): Promise<ShopResponse<ShopReturnAddress[]>> {
  return http.get<never, ShopResponse<ShopReturnAddress[]>>("/shop/merchant/returnAddress/list", { signal });
}
export function saveShopReturnAddress(data: ShopReturnAddressWrite): Promise<ShopResponse<unknown>> {
  return http.post<never, ShopResponse<unknown>>(`/shop/merchant/returnAddress/${data.id == null ? "add" : "edit"}`, data);
}
export function deleteShopReturnAddress(id: number): Promise<ShopResponse<unknown>> {
  return http.delete<never, ShopResponse<unknown>>(`/shop/merchant/returnAddress/remove/${id}`);
}
export function listReturnAddressAreas(parentId: number, signal?: AbortSignal): Promise<ShopResponse<ReturnAddressArea[]>> {
  return areaTree(parentId, signal);
}
export function formatReturnAddress(address: ShopReturnAddress): string {
  return [address.provinceName, address.cityName, address.districtName, address.detailAddress].filter(Boolean).join("");
}

// 退款审核使用订单权限加载正常地址，无需额外授予地址管理权限。
export function listShopReturnAddressOptions(signal?: AbortSignal): Promise<ShopResponse<ShopReturnAddress[]>> {
  return http.get<never, ShopResponse<ShopReturnAddress[]>>("/shop/merchant/returnAddress/options", { signal });
}
